import React from 'react';
import {
  NavLink,
  Link,
} from 'react-router-dom';
import Box from '@material-ui/core/Box';

import { useTranslation } from 'react-i18next';

import { makeStyles } from '@material-ui/core/styles';
import Hidden from '@material-ui/core/Hidden';
import SpeedDial from '@material-ui/lab/SpeedDial';
import SpeedDialAction from '@material-ui/lab/SpeedDialAction';
import VisibilityIcon from '@material-ui/icons/Visibility';
import Tooltip from '@material-ui/core/Tooltip';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { styles } from './style';
import './style.scss';

// icon
import {
  WaterLevelIcon, RadarIcon, RainIcon, DamIcon, QualityIcon, WaveIcon, RainfallIcon,
  StormIcon, AlertIcon, UrgentIcon,
} from '../../assets/svg/Icon';

const initPath = `/${process.env.REACT_APP_PATH}`;
const withLink = (to, children) => <Link to={to}>{children}</Link>;

const actions = [
  { icon: withLink(`${initPath}infographic-basin-situation`, <UrgentIcon className="iconSvg" />), name: 'อินโฟกราฟิกติดตามสถานการณ์ลุ่มน้ำ' },
  { icon: withLink(`${initPath}wave`, <WaveIcon className="iconSvg" />), name: 'คาดการณ์คลื่น' },
  { icon: withLink(`${initPath}forecast/rainfall`, <RainfallIcon className="iconSvg" />), name: 'คาดการณ์ฝน' },
  { icon: withLink(`${initPath}radar`, <RadarIcon className="iconSvg" />), name: 'เรดาร์' },
  { icon: withLink(`${initPath}storm`, <StormIcon className="iconSvg" />), name: 'พายุ' },
  { icon: withLink(`${initPath}risk`, <AlertIcon className="iconSvg" />), name: 'เตือนภัยน้ำหลากดินถล่ม (EWS)' },
  { icon: withLink(`${initPath}waterquality`, <QualityIcon className="iconSvg" />), name: 'คุณภาพน้ำ' },
  { icon: withLink(`${initPath}dam`, <DamIcon className="iconSvg" />), name: 'อ่างเก็บน้ำ' },
  { icon: withLink(`${initPath}waterlevel`, <WaterLevelIcon className="iconSvg" />), name: 'ระดับน้ำ' },
  { icon: withLink(`${initPath}rainfall`, <RainIcon className="iconSvg" />), name: 'ฝน' },
];

const useStyles = makeStyles(styles);

export default function Sidebar() {
  const { t } = useTranslation();
  const classes = useStyles();
  const [open, setOpen] = React.useState(false);
  const [hidden] = React.useState(false);

  const handleOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  const matches = useMediaQuery('(width:667px)');

  return (
    <>
      <Hidden smDown>
        <Box className="sidebar" justifyContent="center" alignItems="center">
          <Box className="sidebar-top" />
          <Box className="sidebar-body">
            <Box>
              <Tooltip title={t('ฝน 24 ชม.')} placement="right">
                <NavLink to={`${initPath}rainfall`} activeClassName="sidebar-active" className="sidebar-item"><RainIcon fontSize="small" /></NavLink>
              </Tooltip>
            </Box>
            <Box>
              <Tooltip title={t('ระดับน้ำ')} placement="right">
                <NavLink id="sidebar-waterlevel" to={`${initPath}waterlevel`} activeClassName="sidebar-active" className="sidebar-item"><WaterLevelIcon fontSize="small" /></NavLink>
              </Tooltip>
            </Box>
            <Box>
              <Tooltip title={t('แหล่งน้ำ')} placement="right">
                <NavLink to={`${initPath}dam`} activeClassName="sidebar-active" className="sidebar-item"><DamIcon fontSize="small" /></NavLink>
              </Tooltip>
            </Box>
            <Box>
              <Tooltip title={t('คุณภาพน้ำ')} placement="right">
                <NavLink id="sidebar-waterquality" to={`${initPath}waterquality`} activeClassName="sidebar-active" className="sidebar-item"><QualityIcon fontSize="small" /></NavLink>
              </Tooltip>
            </Box>
            {/* <Box>
              <Tooltip title={t('พื้นที่ประกาศภัย')} placement="right">
                <NavLink id="sidebar-risk" to={`${initPath}risk`} activeClassName="sidebar-active" className="sidebar-item"><AlertIcon fontSize="small" /></NavLink>
              </Tooltip>
            </Box> */}
            <Box>
              <Tooltip title={t('พายุ')} placement="right">
                <NavLink to={`${initPath}storm`} activeClassName="sidebar-active" className="sidebar-item"><StormIcon fontSize="small" /></NavLink>
              </Tooltip>
            </Box>
            <Box>
              <Tooltip title={t('เรดาร์')} placement="right">
                <NavLink to={`${initPath}radar`} activeClassName="sidebar-active" className="sidebar-item"><RadarIcon fontSize="small" /></NavLink>
              </Tooltip>
            </Box>
            <Box>
              <Tooltip title={t('คาดการณ์ฝน')} placement="right">
                <NavLink to={`${initPath}forecast/rainfall`} activeClassName="sidebar-active" className="sidebar-item"><RainfallIcon fontSize="small" /></NavLink>
              </Tooltip>
            </Box>
            <Box>
              <Tooltip title={t('คาดการณ์คลื่น')} placement="right">
                <NavLink to={`${initPath}wave`} activeClassName="sidebar-active" className="sidebar-item"><WaveIcon fontSize="small" /></NavLink>
              </Tooltip>
            </Box>
            <Box>
              <Tooltip title={t('อินโฟกราฟิกติดตามสถานการณ์ลุ่มน้ำ')} placement="right">
                <NavLink to={`${initPath}infographic-basin-situation`} activeClassName="sidebar-active" className="sidebar-item"><UrgentIcon fontSize="small" /></NavLink>
              </Tooltip>
            </Box>
          </Box>
          <Box className="sidebar-bottom" />
        </Box>
      </Hidden>
      <Hidden mdUp>
        <div className={classes.speedDialMoblie}>
          <SpeedDial
            ariaLabel="SpeedDial openIcon example"
            className={classes.speedDial}
            hidden={hidden}
            icon={<VisibilityIcon />}
            onClose={handleClose}
            onOpen={handleOpen}
            open={open}
            direction={matches ? 'left' : 'up'}
          >
            {actions.map((action) => (
              <SpeedDialAction
                key={action.name}
                icon={action.icon}
                tooltipTitle={action.name}
                onClick={handleClose}
                className={classes.action}
              />
            ))}
          </SpeedDial>
        </div>
      </Hidden>
    </>
  );
}
